import SideBar from '@oncore/ui/SideBar';
import {
  useMenuList,
} from 'src/components/chrome/hooks';
import ChromeSideBarItem from './ChromeSideBarItem';
import ChromeSideBarParentItem from './ChromeSideBarParentItem';
import { useChromeProductName } from './hooks';
import WorkspaceSwitcher from '../WorkspaceSwitcher';
import { useEnterpriseFeatures, useSelector } from 'src/hooks';
import { EnterpriseFeature } from '@oncore/shared';

const ChromeSideBar = () => {
  const menuList = useMenuList();
  const logo = useChromeProductName();
  const context = useSelector((s) => s.app.currentContext.context);
  let withViewRateBenchmarking = false;

  if (context == 'enterprise') {
    withViewRateBenchmarking = useEnterpriseFeatures([EnterpriseFeature.ViewRateBenchmarking]);
  }

  const footer = (
    <WorkspaceSwitcher/>
  );

  const menuListFiltered = menuList.filter((menu) => {
    if (menu.id.includes('tenant-insight')) {
      if (!withViewRateBenchmarking) {
        return false;
      }
    }
    return true;
  })

  return (
    <SideBar
      logo={logo}
      footer={footer}>
      {
        menuListFiltered.map((menuItem) => {

          if (menuItem.type !== 'top') {
            return null;
          }

          if ('children' in menuItem) {

            return (
              <ChromeSideBarParentItem
                key={menuItem.id}
                menuItem={menuItem}
              />
            );
          }

          return (
            <ChromeSideBarItem
              key={menuItem.id}
              menuItem={menuItem}
            />
          );
        })
      }
    </SideBar>
  );
};

export default ChromeSideBar;
